import * as React from 'react';
import { addClass } from '../../utils';
import './BodyText.css';
import { useId } from '../../utils/hooks/useId';
export const BodyText = (props) => {
    const { htmlId, dataTa, className, ...rest } = props;
    const id = useId(htmlId, ['body text']);
    return React.createElement("p", Object.assign({ id: id.toString(), "data-ta": dataTa, className: addClass('vai-body-text', className) }, rest));
};
//# sourceMappingURL=BodyText.js.map